<template>
    <div class="row m-0">
        <div class="col-12 p-0">
            <table class="table table-bordered text-center">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">
                            {{ `[1] ${monthOrYear.text} 목표 설정 (${goalAccValue.unit})` }}
                        </th>
                        <th scope="col">
                            {{ `[2] ${resultData.predict ? "예상 " : ""}소비량 (${targetUsageValue.unit})` }}
                        </th>
                        <th scope="col">
                            {{ `[3] ${resultData.predict ? "예상 " : ""}절감량 (${savingValue.unit})` }}
                        </th>
                        <th scope="col" class="highlightTableItem">
                            {{ `[4] ${resultData.predict ? "예상 " : ""}절감비율 (%)` }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="tableItem align-middle">
                            {{ goalAccValue.value ? formatNumWithComma(goalAccValue.value) : "-" }}
                        </td>
                        <td class="tableItem align-middle">
                            {{ targetUsageValue.value ? formatNumWithComma(targetUsageValue.value) : "-" }}
                        </td>
                        <td class="tableItem align-middle">
                            {{ savingValue.value ? formatNumWithComma(savingValue.value) : "-" }}
                        </td>
                        <td class="highlightTableItem tableItem align-middle">
                            {{ savingPercent != null && isFinite(savingPercent) ? `${savingPercent}` : "-" }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="!monthOrYear.isMonth" class="col-12 p-0">
            <table class="table table-bordered text-center">
                <thead>
                    <tr class="highlightTableItem">
                        <th scope="col">{{ "구분" }}</th>
                        <th v-for="(reg, index) in resultData.values.regDt" :key="'reg-' + index" scope="col">
                            {{ reg }}
                        </th>
                        <th scope="col">{{ "합계" }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="highlightTableItem">{{ `목표 설정 (${goalUnit})` }}</td>
                        <td
                            v-for="(goal, index) in goalValue.value"
                            :class="calTableColor(index)"
                            :key="'goal-' + index"
                        >
                            <!-- {{ `${formatNumWithComma(goal)} ${goalUnit}` }}<br /> -->
                            {{ formatNumWithComma(goal) }}<br />
                        </td>
                        <td class="customDanger">
                            <!-- {{ `${formatNumWithComma(goalValue.sum)} ${goalUnit}` }} -->
                            {{ formatNumWithComma(goalValue.sum) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="highlightTableItem">{{ `소비량 (${mainUnit})` }}</td>
                        <td
                            v-for="(use, index) in targetValue.value"
                            :class="calTableColor(index)"
                            :key="'use-' + index"
                        >
                            <!-- {{ `${formatNumWithComma(use)} ${mainUnit}` }} -->
                            {{ formatNumWithComma(use) }}
                        </td>
                        <td class="customDanger">
                            <!-- {{ `${formatNumWithComma(targetValue.sum)} ${mainUnit}` }} -->
                            {{ formatNumWithComma(targetValue.sum) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="highlightTableItem">{{ `절감량 (${mainUnit})` }}</td>
                        <td
                            v-for="(save, index) in savingOfYear.value"
                            :key="'saving-' + index"
                            :class="calTableColor(index)"
                        >
                            <!-- {{ `${formatNumWithComma(save)} ${mainUnit}` }} -->
                            {{ formatNumWithComma(save) }}
                        </td>
                        <td class="customDanger">
                            <!-- {{ `${formatNumWithComma(savingOfYear.sum)} ${mainUnit}` }} -->
                            {{ formatNumWithComma(savingOfYear.sum) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="highlightTableItem">{{ "절감률 (%)" }}</td>
                        <td
                            v-for="(per, index) in savingOfYearPercent.value"
                            :class="calTableColor(index)"
                            :key="index + 10000"
                        >
                            <!-- {{ `${formatNumWithComma(filterfalsy(per))} %` }} -->
                            {{ formatNumWithComma(filterfalsy(per)) }}
                        </td>
                        <td class="customDanger">
                            <!-- {{ `${formatNumWithComma(filterfalsy(savingPercent))} %` }} -->
                            {{ formatNumWithComma(filterfalsy(savingPercent)) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12 p-0">
            <p class="mb-1">
                {{ `[1] ${monthOrYear.text} 목표 설정 : 사전 입력된 월간 목표 설정량` }}
            </p>
            <p class="mb-1">
                {{
                    `[2] ${resultData.predict ? "예상 " : ""} 소비량 : ${
                        monthOrYear.text
                    } 소비량 데이터를 회귀분석과 이동평균 보정을 사용하여 추정치`
                }}
            </p>
            <p class="mb-1">
                {{
                    `[3] ${resultData.predict ? "예상 " : ""} 절감량 : [1] 설정 목표량 – [2] ${
                        resultData.predict ? "예상 " : ""
                    } 소비량`
                }}
            </p>
            <p class="mb-3">
                {{
                    `[4] ${resultData.predict ? "예상 " : ""} 절감비율 : [3] ${
                        resultData.predict ? "예상 " : ""
                    } 절감량 / [1] 설정 목표량 * 100`
                }}
            </p>
            <p class="mb-0">
                {{
                    `※ ${
                        resultData.predict ? "예상 " : ""
                    } 절감량 분석은 추이 분석을 위해 매월 7일 이후 조회 가능하고 월 후반기에 갈 수록 정확도가 높아집니다.`
                }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: ["detailInfo", "resultData"],
    components: {},
    data() {
        return {
            yearTableData: null,
            currentMonth: new Date().getMonth(),
            emptyDataMonth: [],
        };
    },
    computed: {
        goalHeader() {
            return this.resultData.headers.find((item) => item.roleType == "Goal") ?? {};
        },
        mainHeader() {
            return this.resultData.headers.find((item) => item.roleType == "Main") ?? {};
        },
        goalUnit() {
            const goalUnit = this.$store.state.units.find((unit) => unit.value == this.goalHeader.unitSmallCode);
            return this.goalHeader.dispUnit ? this.goalHeader.dispUnit : goalUnit.text;
        },
        mainUnit() {
            const mainUnit = this.$store.state.units.find((unit) => unit.value == this.mainHeader.unitSmallCode);
            return this.mainHeader.dispUnit ? this.mainHeader.dispUnit : mainUnit.text;
        },
        monthOrYear() {
            let date;
            if (this.mainHeader.timeDsvn == "DAY") {
                date = {
                    text: "월간",
                    isMonth: true,
                };
            } else
                date = {
                    text: "연간",
                    isMonth: false,
                };
            return date;
        },
        goalAccValue() {
            let goal;
            if (this.goalHeader && this.resultData && this.resultData.accumulate) {
                const item = this.resultData?.accumulate[this.goalHeader.key];
                goal = {
                    value: item[item.length - 1],
                    unit: this.goalUnit,
                };
            } else goal = { value: null, unit: this.goalUnit };
            return goal;
        },
        targetUsageValue() {
            let target;
            if (!this.isEmpty(this.mainHeader)) {
                if (!this.isEmpty(this.resultData.predict)) {
                    const predict = this.resultData.predict[this.mainHeader.key];
                    target = {
                        value: Number.isInteger(predict[predict.length - 1])
                            ? predict[predict.length - 1]
                            : predict[predict.length - 1].toFixed(1),
                        unit: this.mainUnit,
                    };
                } else if (!this.isEmpty(this.resultData.accumulate)) {
                    const value = this.resultData.accumulate[this.mainHeader.key];
                    target = {
                        value: Number.isInteger(value[value.length - 1])
                            ? value[value.length - 1]
                            : value[value.length - 1].toFixed(1),
                        unit: this.mainUnit,
                    };
                } else {
                    target = { value: null, unit: this.mainUnit };
                }
            }
            return target;
        },
        savingValue() {
            if (!this.isEmpty(this.goalAccValue.value) && !this.isEmpty(this.targetUsageValue.value)) {
                let save = {
                    value: (this.goalAccValue.value - Number(this.targetUsageValue.value)).toFixed(1),
                    unit: this.mainUnit,
                };
                return save;
            } else {
                return { value: null, unit: this.mainUnit };
            }
            // let save = {
            //     value: (this.goalAccValue.value - Number(this.targetUsageValue.value)).toFixed(1),
            //     unit: this.mainUnit,
            // };
            // return save;
        },
        savingPercent() {
            if (!this.isEmpty(this.savingValue.value) && !this.isEmpty(this.goalAccValue.value)) {
                let percent = ((this.savingValue.value / this.goalAccValue.value) * 100).toFixed(1);
                return percent;
            } else {
                return null;
            }
            // let percent = ((this.savingValue.value / this.goalAccValue.value) * 100).toFixed(1);
            // return percent;
        },
        goalValue() {
            const sum = this.resultData.values[this.goalHeader.key].reduce((acc, cur) => acc + cur, 0);
            const value = {
                value: this.resultData.values[this.goalHeader.key] ?? [],
                sum: sum ?? null,
            };
            return value;
        },
        targetValue() {
            const sum = this.resultData.values[this.mainHeader.key].reduce((acc, cur) => acc + cur, 0);
            const formatValue = this.resultData.values[this.mainHeader.key].map((item) => {
                return Number.isInteger(item) ? item : Number(item).toFixed(1);
            });
            const value = {
                value: formatValue ?? [],
                sum: sum ? sum.toFixed(1) : null,
            };
            return value;
        },
        savingOfYear() {
            const goalValue = this.resultData.values[this.goalHeader.key];
            const mainValue = this.resultData.values[this.mainHeader.key];
            let value = {
                value: [],
                sum: null,
            };
            this.resultData.values.regDt.forEach((item, index) => {
                let saving = (goalValue[index] - mainValue[index]).toFixed(1);
                value.value.push(saving);
            });
            const sum = value.value.reduce((acc, cur) => Number(acc) + Number(cur), 0);
            value.sum = sum ? sum.toFixed(1) : null;
            return value;
        },
        savingOfYearPercent() {
            let value = {
                value: [],
                sum: null,
            };
            this.resultData.values.regDt.forEach((item, index) => {
                let save = this.savingOfYear.value[index] ? this.savingOfYear.value[index] : 0;
                let goal = this.goalValue.value[index] !== null ? this.goalValue.value[index] : 0;
                let per = save / goal ? ((save / goal) * 100).toFixed(1) : 0;
                value.value.push(per);
            });

            return value;
        },
        sumDisPercentValue() {
            return ((this.sumDisValue / this.sumTargetValue) * 100).toFixed(0);
        },
    },
    watch: {
        resultData: {
            deep: true,
            handler() {
                this.notCalMonth();
            },
        },
    },
    created() {},
    mounted() {
        this.notCalMonth();
    },
    methods: {
        filterfalsy(value) {
            if (value != null && isFinite(value)) {
                return value;
            } else {
                return "-";
            }
        },
        calTableColor(index) {
            if (this.emptyDataMonth.includes(index)) {
                return "empty";
            } else if (index < this.currentMonth) {
                return "exist";
            } else {
                return "predict";
            }
        },
        notCalMonth() {
            const findMainHeader = this.detailInfo.variables.find((item) => item.roleType == "Main");
            this.emptyDataMonth = this.resultData.values[findMainHeader.name]
                .map((item, index) => (item === null ? index : null))
                .filter((index) => index !== null);
        },
        formatNumWithComma(value) {
            if (value == null || isNaN(value)) return "-";
            let num = Number(value);
            return num.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        },
        formatValue(value) {
            if (value >= 1e9) {
                return Number.isInteger(value / 1e9) ? value / 1e9 + "G" : (value / 1e9).toFixed(1) + "G";
            } else if (value >= 1e6) {
                return Number.isInteger(value / 1e6) ? value / 1e6 + "M" : (value / 1e6).toFixed(1) + "M";
            } else if (value >= 1e3) {
                return Number.isInteger(value / 1e3) ? value / 1e3 + "K" : (value / 1e3).toFixed(1) + "K";
            } else {
                return Number.isInteger(value) ? value.toString() : Number(value).toFixed(1);
            }
        },
    },
};
</script>
<style scoped>
.empty {
    background-color: white;
}
.exist {
    background-color: #fff3e0;
}
.predict {
    background-color: #e8f5e9;
}
.customDanger {
    background-color: #e8eaf6;
    font-weight: bold;
}
.highlightTableItem {
    background-color: #eceff1;
}
.tableItem {
    height: 50px;
    font-weight: bold;
    font-size: 13px;
}
</style>
